<ng-container [formGroup]="formRef">
  <div class="consent-preview-html" *ngIf="(previewHtml$ | async) as previewHtml;" [innerHTML]="previewHtml"></div>

  <ul class="consent-list">
    <ng-container formArrayName="consents">

      <li class="consent-list__item" *ngFor="let control of controls; index as i" [formGroupName]="i">
        <ng-container [ngSwitch]="(config$|async)?.resultsMode">
          <ng-container
            *ngSwitchCase="resultModeEnum.ONLY_FORM"
            [ngTemplateOutlet]="onlyFormControl"
            [ngTemplateOutletContext]="{ header: control?.value?.header, decisionControl: $any(controls[i].get('decision')) }"></ng-container>
          <ng-container
            *ngSwitchCase="resultModeEnum.FORM_WITH_PREVIEW_HTML"
            [ngTemplateOutlet]="formControlWithPreviewHtml"
            [ngTemplateOutletContext]="{ header: control?.value?.header, id: control?.value?.id, decisionControl: $any(controls[i].get('decision')) }"></ng-container>
        </ng-container>
      </li>

    </ng-container>
  </ul>

</ng-container>

<ng-template #onlyFormControl let-header="header" let-decisionControl="decisionControl">
  <p class="consent-list__paragraph">{{ header || ('APP.GENERAL.NO_RESULT' | translate) }}</p>
  <mat-radio-group class="consent-list__radio" [formControl]="decisionControl">
    <mat-radio-button [value]="customerDecisionEnum.ACCEPTED">{{
        'APP.GENERAL.YES' | translate
      }}
    </mat-radio-button>
    <mat-radio-button [value]="customerDecisionEnum.DENIED">{{
        'APP.GENERAL.NO' | translate
      }}
    </mat-radio-button>
  </mat-radio-group>
</ng-template>

<ng-template #formControlWithPreviewHtml let-header="header" let-decisionControl="decisionControl" let-id="id">
  <p class="consent-list__paragraph">
    {{ header || ('APP.GENERAL.NO_RESULT' | translate) }}
    <button
      class="button button--small button--secondary button--spinner"
      type="button"
      [disabled]="!!resultPreviewHtmlMap[id]?.html"
      mat-icon-button
      (click)="onFetchItemHtml(id)">
      <span *ngIf="!resultPreviewHtmlMap[id]?.isFetching">{{ 'APP.GENERAL.DETAILS' | translate }}</span>
      <app-button-spinner *ngIf="resultPreviewHtmlMap[id]?.isFetching"></app-button-spinner>
    </button>
  </p>
  <div *ngIf="resultPreviewHtmlMap[id]?.html as previewHtml" class="consent-preview-html small" [innerHTML]="previewHtml"></div>
  <mat-radio-group class="consent-list__radio" [formControl]="decisionControl">
    <mat-radio-button [value]="customerDecisionEnum.ACCEPTED">{{
        'APP.GENERAL.YES' | translate
      }}
    </mat-radio-button>
    <mat-radio-button [value]="customerDecisionEnum.DENIED">{{
        'APP.GENERAL.NO' | translate
      }}
    </mat-radio-button>
  </mat-radio-group>
</ng-template>
